<template>
<div id="login">

  <v-toolbar
    dense
    flat
    height="20px"
    color="secondary"
  >
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            class="text-xs-center"
            mt-5
          >
            <h1>
              <img
                src="@/assets/logo.png"
                alt="Ommini Pré-Pago"
                class="mb-5"
              ></h1>
            <h2>Grupo</h2>

            </v-flex>
            <v-flex
              xs12
              sm6
              offset-sm3
              mt-3
            >
              <form >
                <v-layout column>
                  <v-flex>
                    <v-text-field
                     ref="email" 
                     color="terciary"
                      v-model="login.email"
                      append-icon="email"
                      name="email"
                      label="Email"
                      id="email"
                      type="text"
                      required
                      autofocus
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                     color="terciary"
                      v-model="login.senha"
                      append-icon="vpn_key"
                      :rules="senhaRules"
                      name="password"
                      label="Senha"
                      id="password"
                      type="password"
                      required
                      @keyup.enter.native="logar()"
                    ></v-text-field>

                      <!--<div class="error" v-if="!$v.login.senha.required">Validação </div>-->

                  </v-flex>
                  <v-progress-linear
                    color="carregando"
                    v-show="loading"
                    :indeterminate="true"
                  ></v-progress-linear>
                    <v-flex class="text-xs-center">
                      <v-btn
                        class="black--text"
                        color="secondary"
                        large
                        @click="logar()"
                        type="button"
                      >Acessar </v-btn>
                    </v-flex>

                    <v-flex>
                      <v-btn
                        small
                        outline
                        color="terciary"
                        @click.stop="dialog = !dialog;loadingResetSenha=false;reset.email=''"
                      >Esqueceu a senha?</v-btn>
                    </v-flex>

                </v-layout>
              </form>

              <v-snackbar
                :timeout="tempo"
                :color="error"
                :multi-line="'multi-line'"
                :vertical="mode === 'vertical'"
                v-model="snackbar"
              >
                {{ textSnack }}
                <v-btn
                  dark
                  flat
                  @click.native="snackbar = false"
                >Fechar</v-btn>
                  </v-snackbar>

                  <v-snackbar
                    :timeout="10000"
                    :color="sucesso"
                    :multi-line="'multi-line'"
                    :vertical="mode === 'vertical'"
                    v-model="snackbarSuccess"
                  >Você receberá um email com os procedimentos para redefinição de sua senha.
                    <v-btn
                      dark
                      flat
                      @click.native="snackbarSuccess = false"
                    >Fechar</v-btn>
                  </v-snackbar>

                      </v-flex>
                      </v-layout>
      </v-container>
    </v-content>
    <template>
      <v-layout
        row
        justify-center
      >
        <v-dialog
          v-model="dialog"
          persistent
          max-width="500px"
        >

          <v-card>
            <v-card-title>
              <span class="headline">Esqueceu a Senha?</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="reset.email"
                      label="E-mail"
                      required
                    ></v-text-field>
                  </v-flex>

                </v-layout>
              </v-container>
              <small>*Campo requerido</small>
              <v-progress-linear
                :indeterminate="true"
                color="carregando"
                v-show="loadingResetSenha"
              >
                </v-progress-linear>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#EA9F12"
                @click.native="dialog = false"
              >Cancelar</v-btn>
                <v-btn
                  color="secondary"
                  @click.native=" enviaEmailForget()"
                >Enviar</v-btn>
            </v-card-actions>
          </v-card>
          </v-dialog>
          </v-layout>
    </template>

</div>
</template>




<script>
import { HTTP } from "../services/http.axios.js";
import { required, minLength, between } from "vuelidate/lib/validators";
import EventBus from "../services/EventBus";

export default {
  name: "login",
  data() {
    return {
      reset: {
        email: ""
      },
      emailRules: [
        v => !!v || "Cpf é requerido",
        v => v.length == 11 || "Cpf Menor que o padrão"
      ],
      senhaRules: [v => !!v || "Senha é requerida"],
      textSnack: "",
      snackbar: false,
      snackbarSuccess: false,
      tempo: 5000,
      mode: "",
      info: "f1f1f1",
      error: "error",
      sucesso: "sucesso",
      loading: false,
      loadingResetSenha: false,
      dialog: false,
      login: {
        email: "",
        senha: ""
      }
    };
  },
  validations: {
    login: {
      cpf: {
        required,
        minLength: minLength(11)
      },
      senha: {
        required
      }
    }
  },
  mounted() {
    window.localStorage.setItem("tituloApp", "OMMINI PRÉ-PAGO");
    this.loadingResetSenha = false;
    this.$refs.email.focus();
    //OMMINI Pre Pago
  },
  methods: {
    enviaEmailForget() {
      this.loadingResetSenha = true;
      HTTP.post(`password/email`, this.reset)
        .then(response => {
          console.log(response.data);

          this.dialog = false;
          this.snackbarSuccess = true;
          this.loadingResetSenha = true;
          this.$router.push("login");
        })
        .catch(e => {
          console.log(e.response.data.error);

          this.loadingResetSenha = false;
          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          }
        });
    },

    openRota() {
      this.$router.push("Saldo");
    },

    async logar() {
      this.loading = true;
      await HTTP.post(`users/login/grupo`, this.login)
        .then(response => {
          if (response.data.error) {
            this.textSnack = response.data.error.cpf;
            this.snackbar = true;
          } else {
            window.sessionStorage.setItem("token", response.data.token);
            window.sessionStorage.setItem("nome", response.data.nome);
            EventBus.$emit("mudounome");
            window.sessionStorage.setItem("cnpj", response.data.cpf_cnpj);
            HTTP.defaults.headers.common["authorization"] = `Bearer ${
              response.data.token
            }`;
            setTimeout(() => {
              this.loading = false;
              this.$router.push("movimentacao");
            }, 1000);
            //return true;
          }

          //  console.log(response.data.token)
        })
        .catch(e => {
          this.loading = false;

          this.$refs.email.focus();

          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }

            this.textSnack = itens.join("");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          }
        });

      // this.textSnack = "Informe sua senha"
    }
  }
};
</script>




<style>
#login {
  background-color: "#F1F1F1";
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue